const headerMenuButton = document.querySelector(".header-menu-button");
const headerMenuWrapper = document.querySelector(".header-menu-wrapper");
const headerMenuContentWrapper = document.querySelector(
  ".header-menu-content-wrapper"
);
const menuCloseButton = document.querySelector(".menu-close-button");

function lockBodyScroll() {
  document.body.classList.add("no-scroll");
  document.documentElement.classList.add("no-scroll");
  // Prevent touchmove on background, but allow on menu content (for iOS)
  document.addEventListener("touchmove", preventBodyScroll, { passive: false });
}

function unlockBodyScroll() {
  document.body.classList.remove("no-scroll");
  document.documentElement.classList.remove("no-scroll");
  document.removeEventListener("touchmove", preventBodyScroll, {
    passive: false,
  });
}

// Prevent scroll on body, allow only on menu
function preventBodyScroll(e) {
  if (headerMenuWrapper && !headerMenuWrapper.contains(e.target)) {
    e.preventDefault();
  }
}

// Prevent scroll chaining/bounce on iOS and all browsers
function preventScrollBounce(el) {
  if (!el) return;
  el.addEventListener("touchstart", function () {
    const top = el.scrollTop;
    const totalScroll = el.scrollHeight;
    const currentScroll = top + el.offsetHeight;
    // If at the top, scroll down 1px to allow scroll
    if (top === 0) {
      el.scrollTop = 1;
    }
    // If at the bottom, scroll up 1px to allow scroll
    else if (currentScroll === totalScroll) {
      el.scrollTop = top - 1;
    }
  });
  el.addEventListener("touchmove", function (e) {
    if (el.offsetHeight < el.scrollHeight) {
      e._isScroller = true;
    }
  });
}

if (headerMenuButton && headerMenuWrapper) {
  headerMenuButton.addEventListener("click", function () {
    headerMenuWrapper.classList.toggle("open");

    if (window.innerWidth < 750) {
      if (headerMenuWrapper.classList.contains("open")) {
        lockBodyScroll();
        preventScrollBounce(headerMenuWrapper);
      } else {
        unlockBodyScroll();
      }
    } else {
      if (headerMenuWrapper.classList.contains("open")) {
        lockBodyScrollDesktop();
      } else {
        unlockBodyScrollDesktop();
      }
    }
  });

  // Close button click handler
  if (menuCloseButton) {
    menuCloseButton.addEventListener("click", function () {
      headerMenuWrapper.classList.remove("open");
      if (window.innerWidth < 750) {
        unlockBodyScroll();
      } else {
        unlockBodyScrollDesktop();
      }
    });
  }

  // Handle clicks on the wrapper (outside the menu content) - MOBILE ONLY
  headerMenuWrapper.addEventListener("click", function (e) {
    if (e.target === headerMenuWrapper && window.innerWidth < 750) {
      headerMenuWrapper.classList.remove("open");
      unlockBodyScroll();
    }
  });

  function handleMobileClickOutside(e) {
    if (window.innerWidth < 750) {
      const wrapperBounds = headerMenuContentWrapper.getBoundingClientRect();
      const clickX = e.clientX;

      if (
        clickX > wrapperBounds.right &&
        !headerMenuButton.contains(e.target)
      ) {
        headerMenuWrapper.classList.remove("open");
        unlockBodyScroll();
      }
    }
  }

  function setupListeners() {
    if (window.innerWidth < 750) {
      document.addEventListener("click", handleMobileClickOutside);
      unlockBodyScrollDesktop();
    } else {
      document.removeEventListener("click", handleMobileClickOutside);
      unlockBodyScroll();
    }
  }

  setupListeners();
  window.addEventListener("resize", setupListeners);

  // Desktop: close menu and restore scroll on Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && headerMenuWrapper.classList.contains("open")) {
      headerMenuWrapper.classList.remove("open");
      if (window.innerWidth < 750) {
        unlockBodyScroll();
      } else {
        unlockBodyScrollDesktop();
      }
    }
  });
}

// Desktop scroll lock using [scroll-lock] attribute
function lockBodyScrollDesktop() {
  if (window.innerWidth >= 750) {
    document.documentElement.setAttribute("scroll-lock", "");
  }
}

function unlockBodyScrollDesktop() {
  document.documentElement.removeAttribute("scroll-lock");
}

function cleanupScrollLocks() {
  try {
    // Remove any scroll locks
    unlockBodyScrollDesktop();
    unlockBodyScroll();
  } catch (_) {}
}

// Remove scroll lock when page is about to unload (navigation)
window.addEventListener("beforeunload", function () {
  cleanupScrollLocks();
});

// Ensure cleanup when page is shown (including bfcache restores)
window.addEventListener("pageshow", function () {
  cleanupScrollLocks();
});

// Also cleanup on pagehide (fires for bfcache)
window.addEventListener("pagehide", function () {
  cleanupScrollLocks();
});

// Remove scroll lock when menu links are interacted with (pre-navigation)
function handleMenuLinkInteraction(e) {
  // Only act on left-click without modifier keys
  if (
    e.type === "click" &&
    (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)
  ) {
    return;
  }

  // Only within the menu content area
  const inMenuWrapper = e.target.closest(".header-menu-content-wrapper");
  if (!inMenuWrapper) return;

  // Target anchors that navigate within the menu (main links or tiles)
  const link = e.target.closest("a.list-menu__item--link, a.tile");
  if (!link) return;

  // Ignore links that open in new tab/window or JS/no-href
  const href = link.getAttribute("href");
  const target = link.getAttribute("target");
  if (!href || href === "#" || (target && target !== "_self")) return;

  // Defer cleanup to after click so navigation can proceed without breaking hit testing
  setTimeout(() => {
    cleanupScrollLocks();
    // Close the menu UI explicitly on navigation clicks
    const blurDiv = document.querySelector(".header-menu-blur");
    const menuWrapper = document.querySelector(".header-menu-wrapper");
    if (menuWrapper) menuWrapper.classList.remove("open");
    if (blurDiv) blurDiv.style.display = "none";
  }, 0);
}

// Use bubble phase only; remove early mousedown/pointerdown handlers
// Remove previous listeners if any (defensive)
document.removeEventListener("click", handleMenuLinkInteraction, true);
document.removeEventListener("mousedown", handleMenuLinkInteraction, true);
document.removeEventListener("pointerdown", handleMenuLinkInteraction, true);

// Add a single bubble-phase click listener
document.addEventListener("click", handleMenuLinkInteraction);

// Force hard navigation for collection links when grid container is absent
function hasCollectionGridContainer() {
  return !!(
    document.getElementById("ProductGridContainer") ||
    document.getElementById("product-grid")
  );
}

function isHeaderMenuLink(el) {
  return !!(
    el &&
    el.closest(".header-menu-content-wrapper") &&
    el.closest("a")
  );
}

document.addEventListener(
  "click",
  function (e) {
    const link = e.target.closest("a");
    if (!link) return;
    if (!isHeaderMenuLink(link)) return;
    // Only act on primary left-click without modifiers
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)
      return;
    const href = link.getAttribute("href");
    if (!href || href === "#") return;

    if (!hasCollectionGridContainer()) {
      // No grid container present -> avoid SPA replacement; do a full navigation
      e.preventDefault();
      e.stopPropagation();
      cleanupScrollLocks();
      // Close menu UI before navigating
      const blurDiv = document.querySelector(".header-menu-blur");
      const menuWrapper = document.querySelector(".header-menu-wrapper");
      if (menuWrapper) menuWrapper.classList.remove("open");
      if (blurDiv) blurDiv.style.display = "none";
      window.location.href = href;
    }
  },
  true
);
